<template>
  <section>
    <slot />
    <ul class="offers">
      <li v-for="(offer, index) in offers" :key="index" class="offer">
        <translate
          class="offerpercentage"
          :tt="{ discount: offer.discountPercent / 100 }"
        >
          {discount, number, percent} off
        </translate>
        <span class="offername">{{ offer.name }}</span>
        <span class="offerdates">
          <pu-date :date="offer.fromDate" options="long" />
          –
          <br />
          <pu-date :date="offer.toDate" options="long" />
        </span>
      </li>
    </ul>
  </section>
</template>
<script lang="ts">
import { PitchTypeActiveOffer } from '../../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class PitchTypeOffers extends Vue {
  @Prop({ required: true })
  offers: PitchTypeActiveOffer[]
}

export default toNative(PitchTypeOffers)
</script>
<style>
@import url('~/assets/css/offers.css');
</style>
<style scoped>
section {
  margin: 1.3em 0;
}
</style>
